import { render } from "./ListProduto.vue?vue&type=template&id=b1223858"
import script from "./ListProduto.vue?vue&type=script&lang=js"
export * from "./ListProduto.vue?vue&type=script&lang=js"

import "./ListProduto.vue?vue&type=style&index=0&id=b1223858&lang=css"

import exportComponent from "/Users/robo1/Documents/Admin/campanha-pedido/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__